/* global $ */
import React, {
  createContext,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Utils from "../Middleware/Utils";

const initialState = {
  loading: false,
};

export const AuthContextProvider = createContext(initialState);

const AuthContext = ({ children }) => {
  /* -------------------------------------------------------------------------- */
  /*                                State Declare                               */
  /* -------------------------------------------------------------------------- */

  const [activeOrganization, setActiveOrganization] = useState([]);
  const [
    activeOrganizationSubscriptionPlan,
    setActiveOrganizationSubscriptionPlan,
  ] = useState(JSON.parse(localStorage.getItem("subscriptionPlan")) || null);
  const [topbar, setTopbar] = useState("block");
  const [fontFamily, setFontFamily] = useState("")
  const [fontSizeHeading, setFontSizeHeading] = useState("")
  const [fontSizeText, setFontSizeText] = useState("")

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loginLoader, setLoginLoader] = useState(false);
  const [professionTypeListData, setProfessionTypeList] = useState([]);
  const [prospectName, setProspectName] = useState("Prospect");
  const [updatedProspectName, setUpdatedProspectName] = useState("");
  const [proposalName, setProposalName] = useState("Proposal");
  const [updatedProposalName, setUpdatedProposalName] = useState("");
  const [EngagementName, setEngagementName] = useState("Engagement Latter");

  const [DefaultVariables, setDefaultVariables] = useState(false);
  const [isAddUpdatePurchaseDone, setIsAddUpdatePurchaseDone] = useState(false);
  const [logoutTimeUpModal, setLogoutTimeUpModal] = useState({
    isPopupOpen: false,
    popupOpenTime: null,
    popupCloseTime: null,
  });

  const problematicInputRef = useRef(null);
  const [RequireErrorMessage, setRequireErrorMessage] = useState(false);

  const [listCount, setListCount] = useState(0);
  const [deviceHeight, setDeviceHeight] = useState(window.innerHeight);
  const [isMobileRecords, setIsMobileRecords] = useState(0);
  const [desktopRecords, setDesktopRecords] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isMenuVisible, setMenuVisible] = useState(false);

  const [orgLoaderList, setOrgLoaderList] = useState(false);
  const [DashboardCountListLoader, setDashboardCountListLoader] =
    useState(false);
  const [DashboardActivityLogLoader, setDashboardActivityLogLoader] =
    useState(false);

  // access permission count
  const [accessCount, SetAccessCount] = useState(-1);
  const totalPage = isMobile
    ? Math.ceil(listCount / isMobileRecords)
    : Math.ceil(listCount / desktopRecords);

  const common = useSelector((state) => state.Storage);

  const toggleMenuVisibility = () => {
    setMenuVisible(!isMenuVisible);
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      if (width <= 768) {
        setIsMobile(true);
      } else if (width > 768) {
        setIsMobile(false);
      }
      // Set isMobile based on width
      setDeviceHeight(height); // Set device height
      if (height <= 360) {
        setDesktopRecords(1);
        setIsMobileRecords(1);
      } else if (height >= 361 && height <= 400) {
        setDesktopRecords(2);
        setIsMobileRecords(2);
      } else if (height >= 401 && height <= 440) {
        setDesktopRecords(3);
        setIsMobileRecords(3);
      } else if (height >= 440 && height <= 520) {
        // Adjusted this condition to properly capture heights >= 841
        setDesktopRecords(4);
        setIsMobileRecords(4);
      } else if (height >= 521 && height <= 600) {
        setDesktopRecords(5);
        setIsMobileRecords(5);
      } else if (height >= 601 && height <= 660) {
        setDesktopRecords(6);
        setIsMobileRecords(6);
      } else if (height >= 661 && height <= 700) {
        setDesktopRecords(7);
        setIsMobileRecords(7);
      } else if (height >= 701 && height <= 740) {
        setDesktopRecords(8);
        setIsMobileRecords(8);
      } else if (height >= 741 && height <= 780) {
        setDesktopRecords(9);
        setIsMobileRecords(9);
      } else if (height >= 781 && height <= 820) {
        setDesktopRecords(9);
        setIsMobileRecords(9);
      } else if (height >= 801 && height <= 840) {
        setDesktopRecords(10);
        setIsMobileRecords(10);
      } else if (height >= 840) {
        setDesktopRecords(11);
        setIsMobileRecords(11);
      } else {
        setDesktopRecords(6);
        setIsMobileRecords(10);
      }
    };
    handleResize(); // Set initial viewport size
    window.addEventListener("resize", handleResize); // Listen for viewport changes
    return () => window.removeEventListener("resize", handleResize); // Clean up on unmount
  }, []);

  useEffect(() => {

    const GetFontFamily = Utils.FontFamily.find((item) => item.value == common.fontFamilyID)
    const GetFontSizeHeading = Utils.FontSize.find((item) => item.value == common.fontSizeHeading)
    const GetFontSizeText = Utils.FontSize.find((item) => item.value == common.fontSizeText)

    setFontFamily(GetFontFamily?.label)
    setFontSizeHeading(GetFontSizeHeading?.label)
    setFontSizeText(GetFontSizeText?.label)

  }, [common.fontFamilyID, common.fontSizeHeading, common.fontSizeText])

  const scrollUptoCurrentPosition = (e, scrollbarContainerDivRef) => {
    const activeElement = document.activeElement;
    const isReactSelectInput =
      activeElement &&
      activeElement.id.startsWith("react-select-") &&
      activeElement.tagName === "INPUT";

    if (isReactSelectInput && scrollbarContainerDivRef.current) {
      const containerRect =
        scrollbarContainerDivRef.current.getBoundingClientRect();
      const clickedPosition = e.clientY - containerRect.top;
      const containerHeight = containerRect.height;

      // Calculate the target scroll position
      let targetScroll =
        scrollbarContainerDivRef.current.scrollTop +
        clickedPosition -
        containerHeight / 2;

      // Ensure we don't scroll past the bottom
      const maxScroll =
        scrollbarContainerDivRef.current.scrollHeight - containerHeight;
      targetScroll = Math.min(targetScroll, maxScroll);

      // Ensure we don't scroll above the top
      targetScroll = Math.max(targetScroll, 0);

      const smoothScroll = (start, end, duration) => {
        const startTime = performance.now();

        const animateScroll = (currentTime) => {
          const elapsedTime = currentTime - startTime;
          const progress = Math.min(elapsedTime / duration, 1);
          scrollbarContainerDivRef.current.scrollTop =
            start + (end - start) * progress;

          if (progress < 1) {
            requestAnimationFrame(animateScroll);
          }
        };

        requestAnimationFrame(animateScroll);
      };

      const startScroll = scrollbarContainerDivRef.current.scrollTop;
      const duration = 500; // Duration in milliseconds
      smoothScroll(startScroll, targetScroll, duration);
    }
  };
  // Example usage: add an event listener to call the function on a specific event
  // Assume `scrollbarContainerDivRef` is a React ref attached to the container div
  document.addEventListener("click", (e) => {
    const scrollbarContainerDivRef = {
      current: document.getElementById("scrollbarContainer"),
    };
    scrollUptoCurrentPosition(e, scrollbarContainerDivRef);
  });

  const scrollUpDownByElementID = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // Set your static currency symbols here
  const staticCurrencySymbols = {
    currency1: "$", // Example: US Dollar
    currency2: "€", // Example: Euro
    currency3: "₹", // Example: Rupee
  };

  const getCrudButtonTextName = (actionName, moduleName) => {
    let crudButtonTextName = "";
    if (actionName === "Cancel") {
      crudButtonTextName = actionName;
    } else {
      crudButtonTextName = actionName + " " + moduleName;
    }
    return crudButtonTextName;
  };

  const getCrudPopUpTitleName = (actionName, moduleName) => {
    let crudPopUpTitleName = actionName + " " + moduleName;
    return crudPopUpTitleName;
  };

  const getCrudButtonToolTipName = (actionName, moduleName) => {
    let crudButtonToolTipName = "";
    if (moduleName === undefined) {
      crudButtonToolTipName = actionName;
    } else {
      crudButtonToolTipName = actionName + " " + moduleName;
    }
    return crudButtonToolTipName;
  };

  const getPlaceholderTextName = (actionName, moduleName) => {
    let placeholderText = actionName + " " + moduleName;
    return placeholderText;
  };

  const isValidEmail = (email) => {
    const emailRegex =
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*(?!\.{2})\.[A-Za-z]{2,}$/;

    return emailRegex.test(email);
  };

  function formatValue(value, id) {
    // Ensure value is not null
    value = value == null ? 0 : value;

    // Split the value into integer and decimal parts
    let valueArray = value.toString().split(".");
    let valueLength = "";

    // Ensure valueArray[1] is defined and is a string
    if (
      valueArray &&
      valueArray.length > 1 &&
      typeof valueArray[1] === "string"
    ) {
      valueLength = valueArray[1];
    }

    let valueWithExactTwoPrecision = value.toString();

    // Check if valueLength is defined and has a length of at least 2
    if (valueLength && valueLength.length > 2) {
      valueWithExactTwoPrecision = (Math.floor(value * 100) / 100).toFixed(2);
    }

    // Determine the currency symbol based on the id
    let currencySymbol = "";
    switch (1) {
      case 1:
        currencySymbol = "£"; // Pound
        break;
      case 2:
        currencySymbol = "$"; // Dollar
        break;
      case 3:
        currencySymbol = "€"; // Euro
        break;
      // Add more cases for different currency symbols as needed
      default:
        currencySymbol = ""; // Default: No currency symbol
    }

    // Format the value with comma separators
    const formattedValue = `${currencySymbol}${Number(
      valueWithExactTwoPrecision
    )
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

    return `${formattedValue}`;
  }

  function formatValueWithoutCurrencySymbol(value, id) {
    // Ensure value is not null
    value = value == null ? 0 : value;

    // Split the value into integer and decimal parts
    let valueArray = value.toString().split(".");
    let valueLength = "";

    // Ensure valueArray[1] is defined and is a string
    if (
      valueArray &&
      valueArray.length > 1 &&
      typeof valueArray[1] === "string"
    ) {
      valueLength = valueArray[1];
    }

    let valueWithExactTwoPrecision = value.toString();

    // Check if valueLength is defined and has a length of at least 2
    if (valueLength && valueLength.length > 2) {
      valueWithExactTwoPrecision = (Math.floor(value * 100) / 100).toFixed(2);
    }

    // Format the value with comma separators
    const formattedValue = `${Number(valueWithExactTwoPrecision)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

    return `${formattedValue}`;
  }

  const GetTwoDecimalValueWithoutRoundOff = (value) => {
    value = value == null ? 0 : value;
    let valueArray = value.toString().split(".");
    let valueLength = "";

    // Ensure valueArray[1] is defined and is a string
    if (
      valueArray &&
      valueArray.length > 1 &&
      typeof valueArray[1] === "string"
    ) {
      valueLength = valueArray[1];
    }

    let valueWithExactTwoPrecision = value.toString();

    // Check if valueLength is defined and has a length of at least 2
    if (valueLength && valueLength.length > 2) {
      valueWithExactTwoPrecision = Number(
        Math.floor(value * 100) / 100
      ).toFixed(2);
    }
    return Number(valueWithExactTwoPrecision);
  };
  function hasHyphenAfterNumber(text) {
    const pattern = /(\d)-/g;
    let sanitizedText = text.replace(pattern, "$1"); // Remove hyphen if it follows a digit
    sanitizedText = sanitizedText.replace(/-/g, (match, index) =>
      index === 0 ? match : ""
    ); // Keep hyphen only at the start
    return sanitizedText;
  }
  const getValidationMessage = (
    requireMessage,
    maxDiscountForQC,
    defaultDiscount
  ) => {
    if (!requireMessage) return null;

    const parsedDefaultDiscount = Number(defaultDiscount);

    if (isNaN(parsedDefaultDiscount)) {
      return <span className="validation">Invalid discount</span>;
    }

    const minDiscount = -999.0;
    const maxDiscount = maxDiscountForQC || 100;

    if (
      defaultDiscount !== "" &&
      defaultDiscount !== null &&
      defaultDiscount !== undefined &&
      (parsedDefaultDiscount < minDiscount ||
        parsedDefaultDiscount > maxDiscount)
    ) {
      return (
        <>
          <span className="validation">
            The discount should be between {minDiscount}% and {maxDiscount}%.
          </span>
          <button
            style={{
              fontSize: "12px",
              border: "none",
              background: "transparent",
              color: "#626ED4",
            }}
            className="float-sm-end"
            data-bs-toggle="modal"
            data-bs-target="#pricingModel"
          >
            + Pricing Setting
          </button>
        </>
      );
    }

    return null;
  };
  function isValidNumber(value) {
    // Convert the value to a number
    const number = Number(value);
    if (isNaN(number)) {
      return false; // Not a valid number
    }
    // Convert to a string without scientific notation
    let numberString = number?.toLocaleString("fullwide", {
      useGrouping: false,
    });

    // Split the string to separate the part before and after the decimal point
    const [integerPart] = numberString?.split(".");

    // Regular expression to validate up to 16 digits before the decimal
    let validRange = true;
    if (integerPart !== null && integerPart.length > 16) {
      validRange = false;
    }
    // Test only the integer part against the regex
    return validRange;
  }
  /* -------------- Set All Function Used Globally Throughout The Project ------------ */


  //Variable Replace Functions                                                                        
  const SingleServiceWithCombinedTableView = (Type, RecurringValue, OneOffValue) => {
    return `
    <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
      Recurring Service
    </p>
    <table style="border-collapse: collapse; width: 100%; page-break-inside: avoid; break-inside: avoid;">
      <tr>
        <td style="border: 1px solid black; padding: 8px; width: 50%;">${Type}</td>
        <td style="border: 1px solid black; padding: 8px; width: 50%;text-align: right;">${RecurringValue === null ? formatValue(0) : formatValue(RecurringValue)}</td>
      </tr>
    </table>
    <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
      One-Off Service
    </p>
    <table style="border-collapse: collapse; width: 100%; page-break-inside: avoid; break-inside: avoid;">
      <tr>
        <td style="border: 1px solid black; padding: 8px; width: 50%;">${Type}</td>
        <td style="border: 1px solid black; padding: 8px; width: 50%;text-align: right;">${OneOffValue === null ? formatValue(0) : formatValue(OneOffValue)}</td>
      </tr>
    </table>
  `;
  };

  const GetReplacePackageTableView = (
    RecurringPricingInfo,
    Type,
    servicePackageList
  ) => {
    let PackageOneValue = null;
    let PackageTwoValue = null;
    let PackageThreeValue = null;

    if (Type === "Net Total") {
      PackageOneValue = Number(
        RecurringPricingInfo.packageOneNetTotal >
        Number(RecurringPricingInfo.packageOneDisCountedTotal)
      )
        ? RecurringPricingInfo.packageOneNetTotal
        : RecurringPricingInfo.packageOneDisCountedTotal;
      PackageTwoValue = Number(
        RecurringPricingInfo.packageTwoNetTotal >
        Number(RecurringPricingInfo.packageTwoDisCountedTotal)
      )
        ? RecurringPricingInfo.packageTwoNetTotal
        : RecurringPricingInfo.packageTwoDisCountedTotal;
      PackageThreeValue = Number(
        RecurringPricingInfo.packageThreeNetTotal >
        Number(RecurringPricingInfo.packageThreeDisCountedTotal)
      )
        ? RecurringPricingInfo.packageThreeNetTotal
        : RecurringPricingInfo.packageThreeDisCountedTotal;
    } else if (Type === "Discount") {
      PackageOneValue = RecurringPricingInfo.packageOneDisCount;
      PackageTwoValue = RecurringPricingInfo.packageTwoDisCount;
      PackageThreeValue = RecurringPricingInfo.packageThreeDisCount;
    } else if (Type === "Discounted Total") {
      PackageOneValue = RecurringPricingInfo.packageOneDisCountedTotal;
      PackageTwoValue = RecurringPricingInfo.packageTwoDisCountedTotal;
      PackageThreeValue = RecurringPricingInfo.packageThreeDisCountedTotal;
    } else if (Type === "VAT") {
      PackageOneValue = RecurringPricingInfo.PackageOneVaTPrice;
      PackageTwoValue = RecurringPricingInfo.PackageTwoVaTPrice;
      PackageThreeValue = RecurringPricingInfo.PackageThreeVaTPrice;
    } else if (Type === "Grand Total") {
      PackageOneValue = RecurringPricingInfo.PackageOneGrandTotal;
      PackageTwoValue = RecurringPricingInfo.PackageTwoGrandTotal;
      PackageThreeValue = RecurringPricingInfo.PackageThreeGrandTotal;
    } else if (Type === "Original Price") {
      PackageOneValue = RecurringPricingInfo.packageOneNetTotal;
      PackageTwoValue = RecurringPricingInfo.packageTwoNetTotal;
      PackageThreeValue = RecurringPricingInfo.packageThreeNetTotal;
    } else if (Type === "Default Percentage") {
      PackageOneValue = RecurringPricingInfo.DiscountPercentagePackageOne;
      PackageTwoValue = RecurringPricingInfo.DiscountPercentagePackageTwo;
      PackageThreeValue = RecurringPricingInfo.DiscountPercentagePackageThree;
    } else if (Type === "Discounted Price") {
      PackageOneValue = RecurringPricingInfo.packageOneDisCountedTotal;
      PackageTwoValue = RecurringPricingInfo.packageTwoDisCountedTotal;
      PackageThreeValue = RecurringPricingInfo.packageThreeDisCountedTotal;
    }

    const headers = servicePackageList
      .map(
        (item) =>
          `<th style="border: 1px solid black; padding: 8px; width: 25%;">${item.servicePackageName}</th>`
      )
      .join("");

    let rowValues = "";
    if (servicePackageList.length === 1) {
      rowValues = `<td style="border: 1px solid black; padding: 8px;text-align:center;width: 25%;">${formatValue(
        PackageOneValue
      )}</td>`;
    } else if (servicePackageList.length === 2) {
      rowValues = `
      <td style="border: 1px solid black; padding: 8px;text-align:right;width: 25%;">${formatValue(
        PackageOneValue
      )}</td>
      <td style="border: 1px solid black; padding: 8px;text-align:right;width: 25%;">${formatValue(
        PackageTwoValue
      )}</td>
    `;
    } else if (servicePackageList.length === 3) {
      rowValues = `
      <td style="border: 1px solid black; padding: 8px;text-align: right;width: 25%;">${formatValue(
        PackageOneValue
      )}</td>
      <td style="border: 1px solid black; padding: 8px;text-align: right;width: 25%;">${formatValue(
        PackageTwoValue
      )}</td>
      <td style="border: 1px solid black; padding: 8px;text-align: right;width: 25%;">${formatValue(
        PackageThreeValue
      )}</td>
    `;
    }
    return `
    <table style="border-collapse: collapse; width: 100%; page-break-inside: avoid; break-inside: avoid;">
      <tr>
        <th style="border: 1px solid black; padding: 8px;width: 25%;">Package Name</th>
        ${headers}
      </tr>
      <tr>
        <th style="border: 1px solid black; padding: 8px;width: 25%;">${Type}</th>
        ${rowValues}
      </tr>
    </table>`;
  };

  const GetReplacePackageCombinedTableView = (
    RecurringPricingInfo,
    OneOffPricingInfo,
    Type,
    servicePackageList
  ) => {
    let PackageOneValue = null;
    let PackageTwoValue = null;
    let PackageThreeValue = null;

    let PackageOneOneOffValue = null;
    let PackageTwoOneOffValue = null;
    let PackageThreeOneOffValue = null;

    if (Type === "Net Total") {
      PackageOneValue = Number(
        RecurringPricingInfo.packageOneNetTotal) >
        Number(RecurringPricingInfo.packageOneDisCountedTotal)
        ? RecurringPricingInfo.packageOneNetTotal
        : RecurringPricingInfo.packageOneDisCountedTotal;

      PackageTwoValue = Number(
        RecurringPricingInfo.packageTwoNetTotal) >
        Number(RecurringPricingInfo.packageTwoDisCountedTotal)
        ? RecurringPricingInfo.packageTwoNetTotal
        : RecurringPricingInfo.packageTwoDisCountedTotal;

      PackageThreeValue = Number(
        RecurringPricingInfo.packageThreeNetTotal) >
        Number(RecurringPricingInfo.packageThreeDisCountedTotal)
        ? RecurringPricingInfo.packageThreeNetTotal
        : RecurringPricingInfo.packageThreeDisCountedTotal;


      PackageOneOneOffValue = Number(
        OneOffPricingInfo.packageOneNetTotal) >
        Number(OneOffPricingInfo.packageOneDisCountedTotal)
        ? OneOffPricingInfo.packageOneNetTotal
        : OneOffPricingInfo.packageOneDisCountedTotal;

      PackageTwoOneOffValue = Number(
        OneOffPricingInfo.packageTwoNetTotal) >
        Number(OneOffPricingInfo.packageTwoDisCountedTotal)
        ? OneOffPricingInfo.packageTwoNetTotal
        : OneOffPricingInfo.packageTwoDisCountedTotal;

      PackageThreeOneOffValue = Number(
        OneOffPricingInfo.packageThreeNetTotal) >
        Number(OneOffPricingInfo.packageThreeDisCountedTotal)
        ? OneOffPricingInfo.packageThreeNetTotal
        : RecurringPricingInfo.packageThreeDisCountedTotal;
    } else if (Type === "Discount") {
      PackageOneValue = RecurringPricingInfo.packageOneDisCount;
      PackageTwoValue = RecurringPricingInfo.packageTwoDisCount;
      PackageThreeValue = RecurringPricingInfo.packageThreeDisCount;

      PackageOneOneOffValue = OneOffPricingInfo.packageOneDisCount;
      PackageTwoOneOffValue = OneOffPricingInfo.packageTwoDisCount;
      PackageThreeOneOffValue = OneOffPricingInfo.packageThreeDisCount;
    } else if (Type === "Discounted Total") {
      PackageOneValue = RecurringPricingInfo.packageOneDisCountedTotal;
      PackageTwoValue = RecurringPricingInfo.packageTwoDisCountedTotal;
      PackageThreeValue = RecurringPricingInfo.packageThreeDisCountedTotal;

      PackageOneOneOffValue = OneOffPricingInfo.packageOneDisCountedTotal;
      PackageTwoOneOffValue = OneOffPricingInfo.packageTwoDisCountedTotal;
      PackageThreeOneOffValue = OneOffPricingInfo.packageThreeDisCountedTotal;
    } else if (Type === "VAT") {
      PackageOneValue = RecurringPricingInfo.PackageOneVaTPrice;
      PackageTwoValue = RecurringPricingInfo.PackageTwoVaTPrice;
      PackageThreeValue = RecurringPricingInfo.PackageThreeVaTPrice;

      PackageOneOneOffValue = OneOffPricingInfo.PackageOneVaTPrice;
      PackageTwoOneOffValue = OneOffPricingInfo.PackageTwoVaTPrice;
      PackageThreeOneOffValue = OneOffPricingInfo.PackageThreeVaTPrice;
    } else if (Type === "Grand Total") {
      PackageOneValue = RecurringPricingInfo.PackageOneGrandTotal;
      PackageTwoValue = RecurringPricingInfo.PackageTwoGrandTotal;
      PackageThreeValue = RecurringPricingInfo.PackageThreeGrandTotal;

      PackageOneOneOffValue = OneOffPricingInfo.PackageOneGrandTotal;
      PackageTwoOneOffValue = OneOffPricingInfo.PackageTwoGrandTotal;
      PackageThreeOneOffValue = OneOffPricingInfo.PackageThreeGrandTotal;
    } else if (Type === "Original Price") {
      PackageOneValue = RecurringPricingInfo.packageOneNetTotal;
      PackageTwoValue = RecurringPricingInfo.packageTwoNetTotal;
      PackageThreeValue = RecurringPricingInfo.packageThreeNetTotal;

      PackageOneOneOffValue = OneOffPricingInfo.packageOneNetTotal;
      PackageTwoOneOffValue = OneOffPricingInfo.packageTwoNetTotal;
      PackageThreeOneOffValue = OneOffPricingInfo.packageThreeNetTotal;
    } else if (Type === "Default Percentage") {
      PackageOneValue = RecurringPricingInfo.DiscountPercentagePackageOne;
      PackageTwoValue = RecurringPricingInfo.DiscountPercentagePackageTwo;
      PackageThreeValue = RecurringPricingInfo.DiscountPercentagePackageThree;

      PackageOneOneOffValue = OneOffPricingInfo.DiscountPercentagePackageOne;
      PackageTwoOneOffValue = OneOffPricingInfo.DiscountPercentagePackageTwo;
      PackageThreeOneOffValue = OneOffPricingInfo.DiscountPercentagePackageThree;
    } else if (Type === "Discounted Price") {
      PackageOneValue = RecurringPricingInfo.packageOneDisCountedTotal;
      PackageTwoValue = RecurringPricingInfo.packageTwoDisCountedTotal;
      PackageThreeValue = RecurringPricingInfo.packageThreeDisCountedTotal;

      PackageOneOneOffValue = OneOffPricingInfo.packageOneDisCountedTotal;
      PackageTwoOneOffValue = OneOffPricingInfo.packageTwoDisCountedTotal;
      PackageThreeOneOffValue = OneOffPricingInfo.packageThreeDisCountedTotal;
    }

    const headers = servicePackageList
      .map(
        (item) =>
          `<th style="border: 1px solid black; padding: 8px;">${item.servicePackageName}</th>`
      )
      .join("");

    let rowValues = "";
    if (servicePackageList.length === 1) {
      rowValues = `<td style="border: 1px solid black; padding: 8px;width: 25%;text-align: right;"> <ul>
        <li>Recurring Services: ${formatValue(PackageOneValue)}</li>
        <li>One-Off Services: ${formatValue(PackageOneOneOffValue)}</li>
      </ul></td>`;
    } else if (servicePackageList.length === 2) {
      rowValues = `
      <td style="border: 1px solid black; padding: 8px;width: 25%;text-align: right;"><ul>
        <li>Recurring Services: ${formatValue(PackageOneValue)}</li>
        <li>One-Off Services: ${formatValue(PackageOneOneOffValue)}</li>
      </ul></td>
      <td style="border: 1px solid black; padding: 8px;width: 25%;text-align: right;"><ul>
        <li>Recurring Services: ${formatValue(PackageTwoValue)}</li>
        <li>One-Off Services: ${formatValue(PackageTwoOneOffValue)}</li>
      </ul></td>
    `;
    } else if (servicePackageList.length === 3) {
      rowValues = `
      <td style="border: 1px solid black; padding: 8px;width: 25%;text-align: right;"><ul>
        <li>Recurring Services: ${formatValue(PackageOneValue)}</li>
        <li>One-Off Services: ${formatValue(PackageOneOneOffValue)}</li>
      </ul></td>
      <td style="border: 1px solid black; padding: 8px;width: 25%;text-align: right;"><ul>
        <li>Recurring Services: ${formatValue(PackageTwoValue)}</li>
        <li>One-Off Services: ${formatValue(PackageTwoOneOffValue)}</li>
      </ul></td>
      <td style="border: 1px solid black; padding: 8px;width: 25%;text-align: right;"><ul>
        <li>Recurring Services: ${formatValue(PackageThreeValue)}</li>
        <li>One-Off Services: ${formatValue(PackageThreeOneOffValue)}</li>
      </ul></td>
    `;
    }

    return `
    <table style="border-collapse: collapse; width: 100%; page-break-inside: avoid; break-inside: avoid;">
      <tr>
        <th style="border: 1px solid black; padding: 8px;width: 25%;">Package Name</th>
        ${headers}
      </tr>
      <tr>
        <th style="border: 1px solid black; padding: 8px;width: 25%;">${Type}</th>
        ${rowValues}
      </tr>
    </table>`;
  };


  const GetReplaceValueByWithComma = (
    RecurringValue,
    OneOffValue,
    selectedProposalTypeValue,
    servicePackageList,
    Type
  ) => {
    if (selectedProposalTypeValue === 3) {
      return `Recurring Services: ${formatValue(RecurringValue)}, One-Off Services: ${formatValue(
        OneOffValue
      )}`;
    } else {
      let PackageOneValue = ""
      let PackageTwoValue = ""
      let PackageThreeValue = ""
      let PackageOneOneOffValue = ""
      let PackageTwoOneOffValue = ""
      let PackageThreeOneOffValue = ""
      if (Type === "Net Total") {
        PackageOneValue = Number(
          RecurringValue.packageOneNetTotal >
          Number(RecurringValue.packageOneDisCountedTotal)
        )
          ? RecurringValue.packageOneNetTotal
          : RecurringValue.packageOneDisCountedTotal;
        PackageTwoValue = Number(
          RecurringValue.packageTwoNetTotal >
          Number(RecurringValue.packageTwoDisCountedTotal)
        )
          ? RecurringValue.packageTwoNetTotal
          : RecurringValue.packageTwoDisCountedTotal;
        PackageThreeValue = Number(
          RecurringValue.packageThreeNetTotal >
          Number(RecurringValue.packageThreeDisCountedTotal)
        )
          ? RecurringValue.packageThreeNetTotal
          : RecurringValue.packageThreeDisCountedTotal;



        PackageOneOneOffValue = Number(
          OneOffValue.packageOneNetTotal >
          Number(OneOffValue.packageOneDisCountedTotal)
        )
          ? OneOffValue.packageOneNetTotal
          : OneOffValue.packageOneDisCountedTotal;
        PackageTwoOneOffValue = Number(
          OneOffValue.packageTwoNetTotal >
          Number(OneOffValue.packageTwoDisCountedTotal)
        )
          ? OneOffValue.packageTwoNetTotal
          : OneOffValue.packageTwoDisCountedTotal;
        PackageThreeOneOffValue = Number(
          OneOffValue.packageThreeNetTotal >
          Number(OneOffValue.packageThreeDisCountedTotal)
        )
          ? OneOffValue.packageThreeNetTotal
          : OneOffValue.packageThreeDisCountedTotal;
      } else if (Type === "Discount") {
        PackageOneValue = RecurringValue.packageOneDisCount;
        PackageTwoValue = RecurringValue.packageTwoDisCount;
        PackageThreeValue = RecurringValue.packageThreeDisCount;

        PackageOneOneOffValue = OneOffValue.packageOneDisCount;
        PackageTwoOneOffValue = OneOffValue.packageTwoDisCount;
        PackageThreeOneOffValue = OneOffValue.packageThreeDisCount;
      } else if (Type === "Discounted Total") {
        PackageOneValue = RecurringValue.packageOneDisCountedTotal;
        PackageTwoValue = RecurringValue.packageTwoDisCountedTotal;
        PackageThreeValue = RecurringValue.packageThreeDisCountedTotal;

        PackageOneOneOffValue = OneOffValue.packageOneDisCountedTotal;
        PackageTwoOneOffValue = OneOffValue.packageTwoDisCountedTotal;
        PackageThreeOneOffValue = OneOffValue.packageThreeDisCountedTotal;
      } else if (Type === "VAT") {
        PackageOneValue = RecurringValue.PackageOneVaTPrice;
        PackageTwoValue = RecurringValue.PackageTwoVaTPrice;
        PackageThreeValue = RecurringValue.PackageThreeVaTPrice;

        PackageOneOneOffValue = OneOffValue.PackageOneVaTPrice;
        PackageTwoOneOffValue = OneOffValue.PackageTwoVaTPrice;
        PackageThreeOneOffValue = OneOffValue.PackageThreeVaTPrice;
      } else if (Type === "Grand Total") {
        PackageOneValue = RecurringValue.PackageOneGrandTotal;
        PackageTwoValue = RecurringValue.PackageTwoGrandTotal;
        PackageThreeValue = RecurringValue.PackageThreeGrandTotal;

        PackageOneOneOffValue = OneOffValue.PackageOneGrandTotal;
        PackageTwoOneOffValue = OneOffValue.PackageTwoGrandTotal;
        PackageThreeOneOffValue = OneOffValue.PackageThreeGrandTotal;
      } else if (Type === "Original Price") {
        PackageOneValue = RecurringValue.packageOneNetTotal;
        PackageTwoValue = RecurringValue.packageTwoNetTotal;
        PackageThreeValue = RecurringValue.packageThreeNetTotal;

        PackageOneOneOffValue = OneOffValue.packageOneNetTotal;
        PackageTwoOneOffValue = OneOffValue.packageTwoNetTotal;
        PackageThreeOneOffValue = OneOffValue.packageThreeNetTotal;
      } else if (Type === "Default Percentage") {
        PackageOneValue = RecurringValue.DiscountPercentagePackageOne;
        PackageTwoValue = RecurringValue.DiscountPercentagePackageTwo;
        PackageThreeValue = RecurringValue.DiscountPercentagePackageThree;

        PackageOneOneOffValue = OneOffValue.DiscountPercentagePackageOne;
        PackageTwoOneOffValue = OneOffValue.DiscountPercentagePackageTwo;
        PackageThreeOneOffValue = OneOffValue.DiscountPercentagePackageThree;
      } else if (Type === "Discounted Price") {
        PackageOneValue = RecurringValue.packageOneDisCountedTotal;
        PackageTwoValue = RecurringValue.packageTwoDisCountedTotal;
        PackageThreeValue = RecurringValue.packageThreeDisCountedTotal;

        PackageOneOneOffValue = OneOffValue.packageOneDisCountedTotal;
        PackageTwoOneOffValue = OneOffValue.packageTwoDisCountedTotal;
        PackageThreeOneOffValue = OneOffValue.packageThreeDisCountedTotal;
      }


      return servicePackageList
        .map(
          (item, index) =>
            `<b>${item.servicePackageName}</b>: Recurring Services: ${formatValue(
              [PackageOneValue, PackageTwoValue, PackageThreeValue][index]
            )}, One-Off Services: ${formatValue(
              [PackageOneOneOffValue, PackageTwoOneOffValue, PackageThreeOneOffValue][index]
            )}`
        )
        .join(", ");
    }
  };

  const GetReplaceValueByWithBulletList = (
    RecurringValue,
    OneOffValue,
    selectedProposalTypeValue,
    servicePackageList,
    Type
  ) => {
    if (selectedProposalTypeValue === 3) {
      return `
      <ul>
        <li>Recurring Services: ${formatValue(RecurringValue)}</li>
        <li>One-Off Services: ${formatValue(OneOffValue)}</li>
      </ul>
    `;
    } else {


      let PackageOneValue = ""
      let PackageTwoValue = ""
      let PackageThreeValue = ""
      let PackageOneOneOffValue = ""
      let PackageTwoOneOffValue = ""
      let PackageThreeOneOffValue = ""
      if (Type === "Net Total") {
        PackageOneValue = Number(
          RecurringValue.packageOneNetTotal >
          Number(RecurringValue.packageOneDisCountedTotal)
        )
          ? RecurringValue.packageOneNetTotal
          : RecurringValue.packageOneDisCountedTotal;
        PackageTwoValue = Number(
          RecurringValue.packageTwoNetTotal >
          Number(RecurringValue.packageTwoDisCountedTotal)
        )
          ? RecurringValue.packageTwoNetTotal
          : RecurringValue.packageTwoDisCountedTotal;
        PackageThreeValue = Number(
          RecurringValue.packageThreeNetTotal >
          Number(RecurringValue.packageThreeDisCountedTotal)
        )
          ? RecurringValue.packageThreeNetTotal
          : RecurringValue.packageThreeDisCountedTotal;



        PackageOneOneOffValue = Number(
          OneOffValue.packageOneNetTotal >
          Number(OneOffValue.packageOneDisCountedTotal)
        )
          ? OneOffValue.packageOneNetTotal
          : OneOffValue.packageOneDisCountedTotal;
        PackageTwoOneOffValue = Number(
          OneOffValue.packageTwoNetTotal >
          Number(OneOffValue.packageTwoDisCountedTotal)
        )
          ? OneOffValue.packageTwoNetTotal
          : OneOffValue.packageTwoDisCountedTotal;
        PackageThreeOneOffValue = Number(
          OneOffValue.packageThreeNetTotal >
          Number(OneOffValue.packageThreeDisCountedTotal)
        )
          ? OneOffValue.packageThreeNetTotal
          : OneOffValue.packageThreeDisCountedTotal;
      } else if (Type === "Discount") {
        PackageOneValue = RecurringValue.packageOneDisCount;
        PackageTwoValue = RecurringValue.packageTwoDisCount;
        PackageThreeValue = RecurringValue.packageThreeDisCount;

        PackageOneOneOffValue = OneOffValue.packageOneDisCount;
        PackageTwoOneOffValue = OneOffValue.packageTwoDisCount;
        PackageThreeOneOffValue = OneOffValue.packageThreeDisCount;
      } else if (Type === "Discounted Total") {
        PackageOneValue = RecurringValue.packageOneDisCountedTotal;
        PackageTwoValue = RecurringValue.packageTwoDisCountedTotal;
        PackageThreeValue = RecurringValue.packageThreeDisCountedTotal;

        PackageOneOneOffValue = OneOffValue.packageOneDisCountedTotal;
        PackageTwoOneOffValue = OneOffValue.packageTwoDisCountedTotal;
        PackageThreeOneOffValue = OneOffValue.packageThreeDisCountedTotal;
      } else if (Type === "VAT") {
        PackageOneValue = RecurringValue.PackageOneVaTPrice;
        PackageTwoValue = RecurringValue.PackageTwoVaTPrice;
        PackageThreeValue = RecurringValue.PackageThreeVaTPrice;

        PackageOneOneOffValue = OneOffValue.PackageOneVaTPrice;
        PackageTwoOneOffValue = OneOffValue.PackageTwoVaTPrice;
        PackageThreeOneOffValue = OneOffValue.PackageThreeVaTPrice;
      } else if (Type === "Grand Total") {
        PackageOneValue = RecurringValue.PackageOneGrandTotal;
        PackageTwoValue = RecurringValue.PackageTwoGrandTotal;
        PackageThreeValue = RecurringValue.PackageThreeGrandTotal;

        PackageOneOneOffValue = OneOffValue.PackageOneGrandTotal;
        PackageTwoOneOffValue = OneOffValue.PackageTwoGrandTotal;
        PackageThreeOneOffValue = OneOffValue.PackageThreeGrandTotal;
      } else if (Type === "Original Price") {
        PackageOneValue = RecurringValue.packageOneNetTotal;
        PackageTwoValue = RecurringValue.packageTwoNetTotal;
        PackageThreeValue = RecurringValue.packageThreeNetTotal;

        PackageOneOneOffValue = OneOffValue.packageOneNetTotal;
        PackageTwoOneOffValue = OneOffValue.packageTwoNetTotal;
        PackageThreeOneOffValue = OneOffValue.packageThreeNetTotal;
      } else if (Type === "Default Percentage") {
        PackageOneValue = RecurringValue.DiscountPercentagePackageOne;
        PackageTwoValue = RecurringValue.DiscountPercentagePackageTwo;
        PackageThreeValue = RecurringValue.DiscountPercentagePackageThree;

        PackageOneOneOffValue = OneOffValue.DiscountPercentagePackageOne;
        PackageTwoOneOffValue = OneOffValue.DiscountPercentagePackageTwo;
        PackageThreeOneOffValue = OneOffValue.DiscountPercentagePackageThree;
      } else if (Type === "Discounted Price") {
        PackageOneValue = RecurringValue.packageOneDisCountedTotal;
        PackageTwoValue = RecurringValue.packageTwoDisCountedTotal;
        PackageThreeValue = RecurringValue.packageThreeDisCountedTotal;

        PackageOneOneOffValue = OneOffValue.packageOneDisCountedTotal;
        PackageTwoOneOffValue = OneOffValue.packageTwoDisCountedTotal;
        PackageThreeOneOffValue = OneOffValue.packageThreeDisCountedTotal;
      }
      return `
      <ul>
        ${servicePackageList
          .map(
            (item, index) => `
          <li>${item.servicePackageName}: Recurring Services: ${formatValue(
              [PackageOneValue, PackageTwoValue, PackageThreeValue][index]
            )}, One-Off Services: ${formatValue(
              [PackageOneOneOffValue, PackageTwoOneOffValue, PackageThreeOneOffValue][index]
            )}</li>
        `
          )
          .join("")}
      </ul>
    `;
    }
  };

  const getPaymentFrequencyLabel = (FrequencyTypeID) => {
    const Payment_Frequency = {
      Yearly: 1,
      HalfYearly: 2,
      Quarterly: 3,
      Monthly: 4,
    };

    switch (FrequencyTypeID) {
      case Payment_Frequency.Yearly:
        return "Yearly";
      case Payment_Frequency.HalfYearly:
        return "Half-Yearly";
      case Payment_Frequency.Quarterly:
        return "Quarterly";
      case Payment_Frequency.Monthly:
        return "Monthly";
      default:
        return "Unknown";
    }
  };

  const ReplaceVariable_WithTableView = (SelectedServiceList, PricingInfo, selectedProposalTypeValue, SelectedPackageList, Type) => {
    if (!SelectedServiceList || SelectedServiceList.length === 0) {
      return "";
    }
    if (selectedProposalTypeValue === 3) {
      const conditionalRecurringNetTotal =
        Number(PricingInfo.OriginalPrice) <
          Number(PricingInfo.DiscountedPrice)
          ? PricingInfo.DiscountedPrice
          : PricingInfo.OriginalPrice;
      const rows = [
        { label: 'Net Total', value: conditionalRecurringNetTotal },
        { label: 'Discount', value: PricingInfo.Discount },
        { label: 'Discounted Price', value: PricingInfo.DiscountedTotal },
        { label: 'VAT', value: PricingInfo.VATPrice },
        { label: 'Grand Total', value: PricingInfo.GrandTotal },
      ];

      return `
          <table style="border-collapse: collapse; width: 100%; margin-bottom: 16px; page-break-inside: avoid; break-inside: avoid;">
            ${rows
          .map(
            ({ label, value }) => `
                  <tr>
                    <td style="font-weight: 600; border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left; width: 60%;">
                      ${label}
                    </td>
                    <td style="font-weight: 600; border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: right; width: 60%;">
                      ${formatValue(value)}
                    </td>
                  </tr>
                `
          )
          .join('')}
          </table>
        `;

    } else {
      const packageData = [
        {
          label: "Package One",
          netTotal: PricingInfo.packageOneNetTotal,
          discountedTotal: PricingInfo.packageOneDisCountedTotal,
          discount: PricingInfo.packageOneDisCount,
          vatPrice: PricingInfo.PackageOneVaTPrice,
          grandTotal: PricingInfo.PackageOneGrandTotal,
          discountPercentage: PricingInfo.DiscountPercentagePackageOne,
        },
        {
          label: "Package Two",
          netTotal: PricingInfo.packageTwoNetTotal,
          discountedTotal: PricingInfo.packageTwoDisCountedTotal,
          discount: PricingInfo.packageTwoDisCount,
          vatPrice: PricingInfo.PackageTwoVaTPrice,
          grandTotal: PricingInfo.PackageTwoGrandTotal,
          discountPercentage: PricingInfo.DiscountPercentagePackageTwo,
        },
        {
          label: "Package Three",
          netTotal: PricingInfo.packageThreeNetTotal,
          discountedTotal: PricingInfo.packageThreeDisCountedTotal,
          discount: PricingInfo.packageThreeDisCount,
          vatPrice: PricingInfo.PackageThreeVaTPrice,
          grandTotal: PricingInfo.PackageThreeGrandTotal,
          discountPercentage: PricingInfo.DiscountPercentagePackageThree,
        },
      ];

      // Add computed properties
      packageData.forEach((pkg) => {
        pkg.netTotal = Math.max(pkg.netTotal, pkg.discountedTotal);
      });

      return `
<table style="border-collapse: collapse; width: 100%; margin-bottom: 16px; page-break-inside: avoid; break-inside: avoid;">
  <!-- Package Names Row -->
  ${Type !== "WithOutName"
          ? `
      <tr>
        <th style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: left; width: 25%;">Package Name</th>
        ${SelectedPackageList.map(
            (pkg) => `
            <th style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: right; width: 25%;">
              ${pkg.servicePackageName}
            </th>
          `
          ).join("")}
      </tr>
    `
          : ""
        }

  <!-- Data Rows -->
 
        <tr>
          <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: left; width: 25%;">Net Total</td>
          ${SelectedPackageList.map((pkg, index) => `
            <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: right; width: 25%;">
              ${formatValue(packageData[index]?.netTotal || 0)}
            </td>
          `).join("")}
        </tr>
        <tr>
          <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: left; width: 25%;">Discount</td>
          ${SelectedPackageList.map((pkg, index) => `
            <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: right; width: 25%;">
              ${formatValue(packageData[index]?.discount || 0)}
            </td>
          `).join("")}
        </tr>
        <tr>
          <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: left; width: 25%;">Discounted Price</td>
          ${SelectedPackageList.map((pkg, index) => `
            <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: right; width: 25%;">
              ${formatValue(packageData[index]?.discountedTotal || 0)}
            </td>
          `).join("")}
        </tr>
        <tr>
          <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: left; width: 25%;">VAT</td>
          ${SelectedPackageList.map((pkg, index) => `
            <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: right; width: 25%;">
              ${formatValue(packageData[index]?.vatPrice || 0)}
            </td>
          `).join("")}
        </tr>
        <tr>
          <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: left; width: 25%;">Grand Total</td>
          ${SelectedPackageList.map((pkg, index) => `
            <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; text-align: right; width: 25%;">
              ${formatValue(packageData[index]?.grandTotal || 0)}
            </td>
          `).join("")}
        </tr>
      
      
</table>
`;


    }


  }
  //single and package service list variable replace function.
  const GetReplaceServiceWithTableView = (selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList) => {
    const generateTableRows = (serviceList) => {
      if (!servicePackageList) {
        // When there is no servicePackageList
        if (!serviceList || serviceList?.length === 0) return "";
        return `
         <table style="border-collapse: collapse; width: 100%; margin-bottom: 16px;page-break-inside: avoid; break-inside: avoid;">
         <tr>
                    <td style="font-weight: 600; border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left; width: 60%;">
Service Name
</td>     
                  </tr>
         ${serviceList
            .map(item =>
              item.servicesList
                .map(
                  subService => `
               
                  <tr>
                    <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left; width: 60%;">
                      ${subService.serviceName}
                    </td>
                    
                  </tr>
                  
                `
                )
                .join('')
            )
            .join('')}
          </table>
      `;
      } else {
        // When servicePackageList is present
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      ${servicePackageList
            .slice(0, 3) // Limit to maximum of 3 packages
            .map((servicePackage, packageIndex) => {
              // Filter services for the current package
              const validServices = serviceList
                .flatMap((serviceCat) =>
                  serviceCat.servicesList.filter((subService) => {
                    return (
                      (packageIndex === 0 &&
                        subService?.servicePackageIDs.includes(subService.packageOneID) &&
                        subService.packageOneValue !== null) ||
                      (packageIndex === 1 &&
                        subService?.servicePackageIDs.includes(subService.packageTwoID) &&
                        subService.packageTwoValue !== null) ||
                      (packageIndex === 2 &&
                        subService?.servicePackageIDs.includes(subService.packageThreeID) &&
                        subService.packageThreeValue !== null)
                    );
                  })
                );

              // Skip rendering the package if no services are available
              if (validServices.length === 0) return '';

              return `
            <table style="border-collapse: collapse; width: 100%; margin-bottom: 16px;page-break-inside: avoid; break-inside: avoid;">
  
            <tr>
                <th colspan="2" style="border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 18px; text-align: center;">
                  ${servicePackage.servicePackageName}
                </th>
              </tr>
                  <tr>
                    <td style="font-weight: 600; border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left; width: 60%;">
Service Name
</td>

                    
                  </tr>
              ${validServices
                  .map(
                    (subService) => `
               
                    <tr>
                      <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left;">
                        ${subService.serviceName}
                      </td>
                    </tr>
                  `
                  )
                  .join('')}
            </table>
          `;
            })
            .join('')}
    `;


      }
    };

    const recurringServices = generateTableRows(selectedRecurringServiceList);
    const oneOffServices = generateTableRows(selectedOneOffServiceList);

    return `
  <div>
  <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
            Recurring Services
          </p>
    ${recurringServices}   
  <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
            One-Off Services
          </p>
    ${oneOffServices}
  </div>
`;
  };

  const GetReplaceServiceWithTableViewWithPrice = (selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList) => {
    const generateTableRows = (serviceList) => {
      if (!servicePackageList) {

        // When there is no servicePackageList
        if (!serviceList || serviceList?.length === 0) return "";
        return ` 
        <table style="border-collapse: collapse; width: 100%; margin-bottom: 16px;page-break-inside: avoid; break-inside: avoid;">
            <tr>
                    <td style="font-weight: 600; border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left; width: 60%;">
Service Name
</td>
                    <td style="font-weight: 600; border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: right; width: 60%;">
Price
</td>

                    
                  </tr>
        ${serviceList
            .map(item =>
              item.servicesList
                .map(
                  subService => `
           
                  <tr>
                    <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left; width: 60%;">
                      ${subService.serviceName}
                    </td>
                    <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: right; width: 30%;">
                        ${subService.price == undefined
                      ? formatValue(
                        subService.quotationPrice
                      )
                      : formatValue(subService.price)}
                      </td>
                  </tr>
                
                `
                )
                .join('')
            )
            .join('')}
            </table>
      `;
      } else {
        // When servicePackageList is present
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      ${servicePackageList
            .slice(0, 3) // Limit to maximum of 3 packages
            .map((servicePackage, packageIndex) => {
              // Filter services for the current package
              const validServices = serviceList
                .flatMap((serviceCat) =>
                  serviceCat.servicesList.filter((subService) => {
                    return (
                      (packageIndex === 0 &&
                        subService?.servicePackageIDs.includes(subService.packageOneID) &&
                        subService.packageOneValue !== null) ||
                      (packageIndex === 1 &&
                        subService?.servicePackageIDs.includes(subService.packageTwoID) &&
                        subService.packageTwoValue !== null) ||
                      (packageIndex === 2 &&
                        subService?.servicePackageIDs.includes(subService.packageThreeID) &&
                        subService.packageThreeValue !== null)
                    );
                  })
                );

              // Skip rendering the package if no services are available
              if (validServices.length === 0) return '';

              return `
            <table style="border-collapse: collapse; width: 100%; margin-bottom: 16px;page-break-inside: avoid; break-inside: avoid;">
              <tr>
                <th colspan="2" style="border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 18px; text-align: center;">
                  ${servicePackage.servicePackageName}
                </th>
              </tr>
                                   <tr>
                    <td style="font-weight: 600; border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left; width: 60%;">
Service Name
</td>
                    <td style="font-weight: 600; border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: right; width: 60%;">
Price
</td>

                    
                  </tr>
              ${validServices
                  .map((subService) => {
                    const packageValue =
                      packageIndex === 0
                        ? subService.packageOneValue
                        : packageIndex === 1
                          ? subService.packageTwoValue
                          : subService.packageThreeValue;

                    return `
   
                    <tr>
                      <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: left; width: 70%;">
                        ${subService.serviceName}
                      </td>
                      <td style="border: 1px solid rgb(10, 10, 10); padding: 8px; font-size: 16px; text-align: right; width: 30%;">
                        ${formatValue(packageValue)}
                      </td>
                    </tr>
                  `;
                  })
                  .join('')}
            </table>
          `;
            })
            .join('')}
    `;

      }
    };

    const recurringServices = generateTableRows(selectedRecurringServiceList);
    const oneOffServices = generateTableRows(selectedOneOffServiceList);

    return `
  <div>
  <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
            Recurring Services
          </p>
    ${recurringServices}   
  <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
            One-Off Services
          </p>
    ${oneOffServices}
  </div>
`;
  };

  const GetReplaceServiceWithCommaView = (selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList) => {
    const generateTableRows = (serviceList) => {
      if (!servicePackageList) {
        // When there is no servicePackageList
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      <p style="margin: 8px 0; line-height: 1.5;">
        ${serviceList
            .map(item =>
              item.servicesList
                .map(subService => subService.serviceName)
                .join(', ')
            )
            .join(', ')}
      </p>
    `;

      } else {
        // When servicePackageList is present
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      ${servicePackageList
            .slice(0, 3) // Limit to a maximum of 3 packages
            .map((servicePackage, packageIndex) => {
              // Filter services for the current package
              const validServices = serviceList
                .flatMap((serviceCat) =>
                  serviceCat.servicesList.filter((subService) => {
                    return (
                      (packageIndex === 0 &&
                        subService?.servicePackageIDs.includes(subService.packageOneID) &&
                        subService.packageOneValue !== null) ||
                      (packageIndex === 1 &&
                        subService?.servicePackageIDs.includes(subService.packageTwoID) &&
                        subService.packageTwoValue !== null) ||
                      (packageIndex === 2 &&
                        subService?.servicePackageIDs.includes(subService.packageThreeID) &&
                        subService.packageThreeValue !== null)
                    );
                  })
                );

              // Skip rendering the package if no services are available
              if (validServices.length === 0) return '';

              return `
            <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
               ${servicePackage.servicePackageName}
            </p>
            <p style="margin: 8px 0;line-height: 1.5;">
              ${validServices.map((subService) => subService.serviceName).join(', ')}
            </p>
          `;
            })
            .join('')}
    `;
      }
    };

    const recurringServices = generateTableRows(selectedRecurringServiceList);
    const oneOffServices = generateTableRows(selectedOneOffServiceList);

    return `
  <div>
  <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
            Recurring Services
          </p>
    ${recurringServices}   
  <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
            One-Off Services
          </p>
    ${oneOffServices}
  </div>
`;
  };

  const GetReplaceServiceWithCommaViewWithPrice = (selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList) => {
    const generateTableRows = (serviceList) => {
      if (!servicePackageList) {
        // When there is no servicePackageList
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      <p style="margin: 8px 0;line-height: 1.5;">
        ${serviceList
            .map(item =>
              item.servicesList
                .map(subService => `${subService.serviceName}: ${subService.price == undefined
                  ? formatValue(
                    subService.quotationPrice
                  )
                  : formatValue(subService.price)}`)
                .join(', ')
            )
            .join(', ')}
      </p>
    `;

      } else {
        // When servicePackageList is present
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      ${servicePackageList
            .slice(0, 3) // Limit to a maximum of 3 packages
            .map((servicePackage, packageIndex) => {
              // Filter services for the current package
              const validServices = serviceList
                .flatMap((serviceCat) =>
                  serviceCat.servicesList.filter((subService) => {
                    return (
                      (packageIndex === 0 &&
                        subService?.servicePackageIDs.includes(subService.packageOneID) &&
                        subService.packageOneValue !== null) ||
                      (packageIndex === 1 &&
                        subService?.servicePackageIDs.includes(subService.packageTwoID) &&
                        subService.packageTwoValue !== null) ||
                      (packageIndex === 2 &&
                        subService?.servicePackageIDs.includes(subService.packageThreeID) &&
                        subService.packageThreeValue !== null)
                    );
                  })
                );

              // Skip rendering the package if no services are available
              if (validServices.length === 0) return '';

              return `
<p style="margin: 8px 0; line-height: 1.5;">
 <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
  ${servicePackage.servicePackageName}:
</p>  ${validServices
                  .map((subService) => {
                    const packageValue =
                      packageIndex === 0
                        ? subService.packageOneValue
                        : packageIndex === 1
                          ? subService.packageTwoValue
                          : subService.packageThreeValue;

                    return `${subService.serviceName}: ${formatValue(packageValue)}`;
                  })
                  .join(', ')}
</p>
`;

            })
            .join('')}
    `;
      }
    };

    const recurringServices = generateTableRows(selectedRecurringServiceList);
    const oneOffServices = generateTableRows(selectedOneOffServiceList);

    return `
    <div>
    <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
              Recurring Services
            </p>
      ${recurringServices}   
    <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
              One-Off Services
            </p>
      ${oneOffServices}
    </div>
  `;
  };

  const GetReplaceServiceWithBulletListView = (selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList) => {
    const generateTableRows = (serviceList) => {
      if (!servicePackageList) {
        // When there is no servicePackageList
        if (!serviceList || serviceList?.length === 0) return "";
        return `
<ul style="margin: 8px 0; font-size: 16px; line-height: 1.5;">
  ${serviceList
            .map(item =>
              item.servicesList
                .map(subService => `<li>${subService.serviceName}</li>`)
                .join('')
            )
            .join('')}
</ul>
`;


      } else {
        // When servicePackageList is present
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      ${servicePackageList
            .slice(0, 3) // Limit to a maximum of 3 packages
            .map((servicePackage, packageIndex) => {
              // Filter services for the current package
              const validServices = serviceList
                .flatMap((serviceCat) =>
                  serviceCat.servicesList.filter((subService) => {
                    return (
                      (packageIndex === 0 &&
                        subService?.servicePackageIDs.includes(subService.packageOneID) &&
                        subService.packageOneValue !== null) ||
                      (packageIndex === 1 &&
                        subService?.servicePackageIDs.includes(subService.packageTwoID) &&
                        subService.packageTwoValue !== null) ||
                      (packageIndex === 2 &&
                        subService?.servicePackageIDs.includes(subService.packageThreeID) &&
                        subService.packageThreeValue !== null)
                    );
                  })
                );

              // Skip rendering the package if no services are available
              if (validServices.length === 0) return '';

              return `
            <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
               ${servicePackage.servicePackageName}
            </p>
            <ul style="margin: 8px 0; font-size: 16px; line-height: 1.5;">
  ${serviceList
                  .map(item =>
                    item.servicesList
                      .map(subService => `<li>${subService.serviceName}</li>`)
                      .join('')
                  )
                  .join('')}
</ul>
          `;
            })
            .join('')}
    `;
      }
    };

    const recurringServices = generateTableRows(selectedRecurringServiceList);
    const oneOffServices = generateTableRows(selectedOneOffServiceList);

    return `
  <div>
  <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
            Recurring Services
          </p>
    ${recurringServices}   
  <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
            One-Off Services
          </p>
    ${oneOffServices}
  </div>
`;
  };

  const GetReplaceServiceWithBulletListViewWithPrice = (selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList) => {
    const generateTableRows = (serviceList) => {
      if (!servicePackageList) {
        // When there is no servicePackageList
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      <ul style="margin: 8px 0; font-size: 16px; line-height: 1.5;">
        ${serviceList
            .map(item =>
              item.servicesList
                .map(subService => `<li>${subService.serviceName}: ${subService.price == undefined
                  ? formatValue(
                    subService.quotationPrice
                  )
                  : formatValue(subService.price)}</li>`)
                .join('')
            )
            .join('')}
      </ul>
    `;




      } else {
        // When servicePackageList is present
        if (!serviceList || serviceList?.length === 0) return "";
        return `
      ${servicePackageList
            .slice(0, 3) // Limit to a maximum of 3 packages
            .map((servicePackage, packageIndex) => {
              // Filter services for the current package
              const validServices = serviceList
                .flatMap((serviceCat) =>
                  serviceCat.servicesList.filter((subService) => {
                    return (
                      (packageIndex === 0 &&
                        subService?.servicePackageIDs.includes(subService.packageOneID) &&
                        subService.packageOneValue !== null) ||
                      (packageIndex === 1 &&
                        subService?.servicePackageIDs.includes(subService.packageTwoID) &&
                        subService.packageTwoValue !== null) ||
                      (packageIndex === 2 &&
                        subService?.servicePackageIDs.includes(subService.packageThreeID) &&
                        subService.packageThreeValue !== null)
                    );
                  })
                );

              // Skip rendering the package if no services are available
              if (validServices.length === 0) return '';

              return `

 <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
  ${servicePackage.servicePackageName}:
</p>
 <ul style="margin: 8px 0; font-size: 16px; line-height: 1.5;">
${validServices
                  .map((subService) => {
                    const packageValue =
                      packageIndex === 0
                        ? subService.packageOneValue
                        : packageIndex === 1
                          ? subService.packageTwoValue
                          : subService.packageThreeValue;

                    return `<li>${subService.serviceName}: ${formatValue(packageValue)}</li>`;
                  })
                  .join(', ')}
                 </ul>

`;

            })
            .join('')}
    `;
      }
    };

    const recurringServices = generateTableRows(selectedRecurringServiceList);
    const oneOffServices = generateTableRows(selectedOneOffServiceList);

    return `
    <div>
    <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
              Recurring Services
            </p>
      ${recurringServices}   
    <p style="font-weight: 600; margin: 8px 0; font-size: 18px;">
              One-Off Services
            </p>
      ${oneOffServices}
    </div>
  `;
  };
  function replaceTemplatePricingVariables(
    array,
    RecurringPricingInfo,
    OneOffPricingInfo,
    paymentFrequency,
    selectedProposalTypeValue,
    servicePackageList,
    selectedRecurringServiceList,
    selectedOneOffServiceList
  ) {
    let ResultTotalVariablesWithValues = {};
    const conditionalRecurringNetTotal =
      Number(RecurringPricingInfo.OriginalPrice) <
        Number(RecurringPricingInfo.DiscountedPrice)
        ? RecurringPricingInfo.DiscountedPrice
        : RecurringPricingInfo.OriginalPrice;
    const conditionalOneOffNetTotal =
      Number(OneOffPricingInfo.OriginalPrice) <
        Number(OneOffPricingInfo.DiscountedPrice)
        ? OneOffPricingInfo.DiscountedPrice
        : OneOffPricingInfo.OriginalPrice;
    //selectProposalTypeValue 3= single(Custumized)
    if (selectedProposalTypeValue === 3) {
      ResultTotalVariablesWithValues = {
        // All Total result variable with table view
        AllRecuringResultTotalVariable_WithPackageName: ReplaceVariable_WithTableView(selectedRecurringServiceList, RecurringPricingInfo, selectedProposalTypeValue, null, null),
        AllOneOffResultTotalVariable_WithPackageName: ReplaceVariable_WithTableView(selectedOneOffServiceList, OneOffPricingInfo, selectedProposalTypeValue, null, null),
        AllRecurringResultTotalVariable_WithoutPackageName: ReplaceVariable_WithTableView(selectedRecurringServiceList, RecurringPricingInfo, selectedProposalTypeValue, null, null),
        AllOneOffResultTotalVariable_WithoutPackageName: ReplaceVariable_WithTableView(selectedOneOffServiceList, OneOffPricingInfo, selectedProposalTypeValue, null, null),
        //service Variable
        AllServices_WithTableView: GetReplaceServiceWithTableView(selectedRecurringServiceList, selectedOneOffServiceList, null),
        AllServicesWithPrice_WithTableView: GetReplaceServiceWithTableViewWithPrice(selectedRecurringServiceList, selectedOneOffServiceList, null),

        AllServices_WithComma: GetReplaceServiceWithCommaView(selectedRecurringServiceList, selectedOneOffServiceList, null),
        AllServicesWithPrice_WithComma: GetReplaceServiceWithCommaViewWithPrice(selectedRecurringServiceList, selectedOneOffServiceList, null),

        AllServices_WithBulletList: GetReplaceServiceWithBulletListView(selectedRecurringServiceList, selectedOneOffServiceList, null),
        AllServicesWithPrice_WithBulletList: GetReplaceServiceWithBulletListViewWithPrice(selectedRecurringServiceList, selectedOneOffServiceList, null),

        //Other services
        Net_Total_Recurring: formatValue(conditionalRecurringNetTotal),
        Discount_Recurring: formatValue(RecurringPricingInfo.Discount),
        Discounted_Total_Recurring: formatValue(
          RecurringPricingInfo.DiscountedTotal
        ),
        VAT_Recurring: formatValue(RecurringPricingInfo.VATPrice),
        Grand_Total_Recurring: formatValue(RecurringPricingInfo.GrandTotal),
        Original_Price_Recurring: formatValue(RecurringPricingInfo.OriginalPrice),
        Discount_Percentage_Recurring: formatValue(
          RecurringPricingInfo.DefaultDiscount
        ),
        Discounted_Price_Recurring: formatValue(
          RecurringPricingInfo.DiscountedTotal
        ),
        Payment_Frequency_Recurring: getPaymentFrequencyLabel(paymentFrequency),

        Net_Total_OneOff: formatValue(conditionalOneOffNetTotal),
        Discount_OneOff: formatValue(OneOffPricingInfo.Discount),
        Discounted_Total_OneOff: formatValue(OneOffPricingInfo.DiscountedTotal),
        VAT_OneOff: formatValue(OneOffPricingInfo.VATPrice),
        Grand_Total_OneOff: formatValue(OneOffPricingInfo.GrandTotal),
        Original_Price_OneOff: formatValue(OneOffPricingInfo.OriginalPrice),
        Discount_Percentage_OneOff: formatValue(
          OneOffPricingInfo.DefaultDiscount
        ),
        Discounted_Price_OneOff: formatValue(OneOffPricingInfo.DiscountedTotal),
        //With Table View
        Net_Total_WithTableView: SingleServiceWithCombinedTableView(
          "Net Total",
          conditionalRecurringNetTotal,
          conditionalOneOffNetTotal
        ),
        Discount_WithTableView: SingleServiceWithCombinedTableView(
          "Discount",
          RecurringPricingInfo.Discount,
          OneOffPricingInfo.Discount,
        ),
        Discounted_Total_WithTableView: SingleServiceWithCombinedTableView(
          "Discounted Total",
          RecurringPricingInfo.DiscountedTotal,
          OneOffPricingInfo.DiscountedTotal,
        ),
        VAT_WithTableView: SingleServiceWithCombinedTableView(
          "VAT",
          RecurringPricingInfo.VATPrice,
          OneOffPricingInfo.VATPrice,
        ),
        Grand_Total_WithTableView: SingleServiceWithCombinedTableView(
          "Grand Total",
          RecurringPricingInfo.GrandTotal,
          OneOffPricingInfo.GrandTotal,
        ),
        Original_Price_WithTableView: SingleServiceWithCombinedTableView(
          "Original Price",
          RecurringPricingInfo.OriginalPrice,
          OneOffPricingInfo.OriginalPrice,
        ),
        Discount_Percentage_WithTableView: SingleServiceWithCombinedTableView(
          "Default Percentage",
          RecurringPricingInfo.DefaultDiscount,
          OneOffPricingInfo.DefaultDiscount,
        ),
        Discounted_Price_WithTableView: SingleServiceWithCombinedTableView(
          "Discounted Price",
          RecurringPricingInfo.DiscountedPrice,
          OneOffPricingInfo.DiscountedPrice,
        ),
        //Comma Seprated
        Net_Total_WithComma: GetReplaceValueByWithComma(
          conditionalRecurringNetTotal,
          conditionalOneOffNetTotal,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Discount_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo.Discount,
          OneOffPricingInfo.Discount,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Discounted_Total_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo.DiscountedTotal,
          OneOffPricingInfo.DiscountedTotal,
          selectedProposalTypeValue,
          servicePackageList
        ),
        VAT_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo.VATPrice,
          OneOffPricingInfo.VATPrice,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Grand_Total_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo.GrandTotal,
          OneOffPricingInfo.GrandTotal,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Original_Price_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo.OriginalPrice,
          OneOffPricingInfo.OriginalPrice,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Discount_Percentage_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo.DefaultDiscount,
          OneOffPricingInfo.DefaultDiscount,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Discounted_Price_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo.DiscountedPrice,
          OneOffPricingInfo.DiscountedPrice,
          selectedProposalTypeValue,
          servicePackageList
        ),

        Net_Total_WithBulletList: GetReplaceValueByWithBulletList(
          conditionalRecurringNetTotal,
          conditionalOneOffNetTotal,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Discount_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo.Discount,
          OneOffPricingInfo.Discount,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Discounted_Total_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo.DiscountedTotal,
          OneOffPricingInfo.DiscountedTotal,
          selectedProposalTypeValue,
          servicePackageList
        ),
        VAT_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo.VATPrice,
          OneOffPricingInfo.VATPrice,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Grand_Total_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo.GrandTotal,
          OneOffPricingInfo.GrandTotal,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Original_Price_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo.OriginalPrice,
          OneOffPricingInfo.OriginalPrice,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Discount_Percentage_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo.DefaultDiscount,
          OneOffPricingInfo.DefaultDiscount,
          selectedProposalTypeValue,
          servicePackageList
        ),
        Discounted_Price_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo.DiscountedPrice,
          OneOffPricingInfo.DiscountedPrice,
          selectedProposalTypeValue,
          servicePackageList
        ),
      };
    } else {
      ResultTotalVariablesWithValues = {
        // All Total result variable with table view
        AllRecuringResultTotalVariable_WithPackageName: ReplaceVariable_WithTableView(selectedRecurringServiceList, RecurringPricingInfo, selectedProposalTypeValue, servicePackageList, null),
        AllOneOffResultTotalVariable_WithPackageName: ReplaceVariable_WithTableView(selectedOneOffServiceList, OneOffPricingInfo, selectedProposalTypeValue, servicePackageList, null),
        AllRecurringResultTotalVariable_WithoutPackageName: ReplaceVariable_WithTableView(selectedRecurringServiceList, RecurringPricingInfo, selectedProposalTypeValue, servicePackageList, "WithOutName"),
        AllOneOffResultTotalVariable_WithoutPackageName: ReplaceVariable_WithTableView(selectedOneOffServiceList, OneOffPricingInfo, selectedProposalTypeValue, servicePackageList, "WithOutName"),
        //service Price replace variables
        AllServices_WithTableView: GetReplaceServiceWithTableView(selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList),
        AllServicesWithPrice_WithTableView: GetReplaceServiceWithTableViewWithPrice(selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList),

        AllServices_WithComma: GetReplaceServiceWithCommaView(selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList),
        AllServicesWithPrice_WithComma: GetReplaceServiceWithCommaViewWithPrice(selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList),

        AllServices_WithBulletList: GetReplaceServiceWithBulletListView(selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList),
        AllServicesWithPrice_WithBulletList: GetReplaceServiceWithBulletListViewWithPrice(selectedRecurringServiceList, selectedOneOffServiceList, servicePackageList),
        //Other Values
        Net_Total_Recurring: GetReplacePackageTableView(
          RecurringPricingInfo,
          "Net Total",
          servicePackageList
        ),
        Discount_Recurring: GetReplacePackageTableView(
          RecurringPricingInfo,
          "Discount",
          servicePackageList
        ),
        Discounted_Total_Recurring: GetReplacePackageTableView(
          RecurringPricingInfo,
          "Discounted Total",
          servicePackageList
        ),
        VAT_Recurring: GetReplacePackageTableView(
          RecurringPricingInfo,
          "VAT",
          servicePackageList
        ),
        Grand_Total_Recurring: GetReplacePackageTableView(
          RecurringPricingInfo,
          "Grand Total",
          servicePackageList
        ),
        Original_Price_Recurring: GetReplacePackageTableView(
          RecurringPricingInfo,
          "Original Price",
          servicePackageList
        ),
        Discount_Percentage_Recurring: GetReplacePackageTableView(
          RecurringPricingInfo,
          "Default Percentage",
          servicePackageList
        ),
        Discounted_Price_Recurring: GetReplacePackageTableView(
          RecurringPricingInfo,
          "Discounted Price",
          servicePackageList
        ),
        Payment_Frequency_Recurring: getPaymentFrequencyLabel(paymentFrequency),

        Net_Total_OneOff: GetReplacePackageTableView(
          OneOffPricingInfo,
          "Net Total",
          servicePackageList
        ),
        Discount_OneOff: GetReplacePackageTableView(
          OneOffPricingInfo,
          "Discount",
          servicePackageList
        ),
        Discounted_Total_OneOff: GetReplacePackageTableView(
          OneOffPricingInfo,
          "Discounted Total",
          servicePackageList
        ),

        VAT_OneOff: GetReplacePackageTableView(
          OneOffPricingInfo,
          "VAT",
          servicePackageList
        ),
        Grand_Total_OneOff: GetReplacePackageTableView(
          OneOffPricingInfo,
          "Grand Total",
          servicePackageList
        ),
        Original_Price_OneOff: GetReplacePackageTableView(
          OneOffPricingInfo,
          "Original Price",
          servicePackageList
        ),
        Discount_Percentage_OneOff: GetReplacePackageTableView(
          OneOffPricingInfo,
          "Default Percentage",
          servicePackageList
        ),
        Discounted_Price_OneOff: GetReplacePackageTableView(
          OneOffPricingInfo,
          "Discounted Price",
          servicePackageList
        ),

        //Table view
        Net_Total_WithTableView: GetReplacePackageCombinedTableView(
          RecurringPricingInfo,
          OneOffPricingInfo,
          "Net Total",
          servicePackageList
        ),
        Discount_WithTableView: GetReplacePackageCombinedTableView(
          RecurringPricingInfo,
          OneOffPricingInfo,
          "Discount",
          servicePackageList
        ),
        Discounted_Total_WithTableView: GetReplacePackageCombinedTableView(
          RecurringPricingInfo,
          OneOffPricingInfo,
          "Discounted Total",
          servicePackageList
        ),
        Discounted_Price_WithTableView: GetReplacePackageCombinedTableView(
          RecurringPricingInfo,
          OneOffPricingInfo,
          "Discounted Price",
          servicePackageList
        ),
        VAT_WithTableView: GetReplacePackageCombinedTableView(
          RecurringPricingInfo,
          OneOffPricingInfo,
          "VAT",
          servicePackageList
        ),
        Grand_Total_WithTableView: GetReplacePackageCombinedTableView(
          RecurringPricingInfo,
          OneOffPricingInfo,
          "Grand Total",
          servicePackageList
        ),
        Original_Price_WithTableView: GetReplacePackageCombinedTableView(
          RecurringPricingInfo,
          OneOffPricingInfo,
          "Original Price",
          servicePackageList
        ),
        Discount_Percentage_WithTableView: GetReplacePackageCombinedTableView(
          RecurringPricingInfo,
          OneOffPricingInfo,
          "Default Percentage",
          servicePackageList
        ),

        Net_Total_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Net Total",
        ),
        Discount_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Discount",
        ),
        Discounted_Total_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList
        ),
        VAT_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "VAT"
        ),
        Grand_Total_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Grand Total"
        ),
        Original_Price_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Original Price"
        ),
        Discount_Percentage_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Default Percentage",
        ),
        Discounted_Price_WithComma: GetReplaceValueByWithComma(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Default Price",
        ),

        Net_Total_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Net Total",
        ),
        Discount_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Discount",
        ),
        Discounted_Total_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList
        ),
        VAT_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "VAT"
        ),
        Grand_Total_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Grand Total"
        ),
        Original_Price_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Original Price"
        ),
        Discount_Percentage_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Default Percentage",
        ),
        Discounted_Price_WithBulletList: GetReplaceValueByWithBulletList(
          RecurringPricingInfo,
          OneOffPricingInfo,
          selectedProposalTypeValue,
          servicePackageList,
          "Default Price",
        ),
      };
    }

    const replacedArray = array.map((item) => {
      if (item.htmlContent) {
        let replacedContent = item.htmlContent;

        // Iterate over each variable and replace it in the content
        for (const variable in ResultTotalVariablesWithValues) {
          let value =
            ResultTotalVariablesWithValues[variable] == null
              ? "0.00"
              : ResultTotalVariablesWithValues[variable];

          const regex = new RegExp(`\\$${variable}\\$`, "g");

          replacedContent = replacedContent.replace(regex, value);
        }
        // Update the htmlContent in the item
        return { ...item, htmlContent: replacedContent };
      } else {
        return item;
      }
    });

    return replacedArray;
  }
  function getFontStylesFromHtml(htmlContent) {
    // Create a temporary DOM element to parse the HTML content
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlContent;

    // Use querySelectorAll to find all elements with the 'style' attribute containing 'font-family' or 'font-size'
    const elementsWithFontStyles = tempElement.querySelectorAll('[style*="font-family"], [style*="font-size"]');

    // Extract the font-family and font-size values
    const fontStyles = Array.from(elementsWithFontStyles).map(element => {
      const fontFamily = element.style.fontFamily || null;
      const fontSize = element.style.fontSize || null;

      // Convert fontSize to a numeric value for comparison
      let numericFontSize = fontSize ? parseFloat(fontSize) : null;
      if (fontSize && fontSize.includes('em')) {
        // Convert 'em' values to pixels assuming 1em = 16px as a general rule
        numericFontSize *= 16;
      }

      let fontSizeCategory = null;
      if (numericFontSize) {
        fontSizeCategory = numericFontSize > 16 ? 'large' : 'small';
      }

      return { fontFamily, fontSize, fontSizeCategory };
    });

    // Convert to a comma-separated string of unique font-family values, removing both single and double quotes
    const uniqueFontFamilies = [...new Set(fontStyles.map(style => style.fontFamily).filter(Boolean))]
      .join(', ')
      .replace(/['"]/g, ''); // Remove both single and double quotes

    // Categorize and collect font sizes based on 'large' or 'small' classification
    const largeFontSizes = fontStyles.filter(style => style.fontSizeCategory === 'large').map(style => style.fontSize);
    const smallFontSizes = fontStyles.filter(style => style.fontSizeCategory === 'small').map(style => style.fontSize);

    return {
      uniqueFontFamilies,
      largeFontSizes: largeFontSizes.join(', '),
      smallFontSizes: smallFontSizes.join(', ')
    };
  }
  const replaceUrlInHtml = (htmlContent) => {
    // Regex to match URLs outside of <img> tags
    const urlRegex = /(?<!<img[^>]*src=["'])\bhttps?:\/\/[^\s<>"']+[\w/]/g;

    // Replace URLs with styled spans
    return htmlContent.replace(urlRegex, (url) => {
      return `<span style="display: block; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; overflow-x: auto; white-space: pre-wrap;">${url}</span>`;
    });
  };
  return (
    <AuthContextProvider.Provider
      value={{
        replaceUrlInHtml,
        fontSizeHeading,
        fontFamily,
        getFontStylesFromHtml,
        fontSizeText,
        isValidNumber,
        topbar,
        loader,
        listCount,
        setTopbar,
        isPopupOpen,
        prospectName,
        setIsPopupOpen,
        proposalName,
        EngagementName,
        setLoader,
        loginLoader,
        setLoginLoader,
        isMobile,
        totalPage,
        formatValue,
        formatValueWithoutCurrencySymbol,
        isValidEmail,
        setListCount,
        accessCount,

        orgLoaderList,
        SetAccessCount,
        desktopRecords,
        isMobileRecords,
        setProposalName,

        DefaultVariables,

        setProspectName,
        setOrgLoaderList,

        setEngagementName,

        activeOrganization,
        updatedProspectName,
        updatedProposalName,
        RequireErrorMessage,
        setDefaultVariables,
        problematicInputRef,
        staticCurrencySymbols,
        setProfessionTypeList,
        setActiveOrganization,
        getCrudButtonTextName,
        getCrudPopUpTitleName,

        setUpdatedProposalName,
        setUpdatedProspectName,
        getPlaceholderTextName,
        professionTypeListData,
        setRequireErrorMessage,
        scrollUpDownByElementID,
        DashboardCountListLoader,

        getCrudButtonToolTipName,

        scrollUptoCurrentPosition,
        DashboardActivityLogLoader,

        setDashboardCountListLoader,

        setDashboardActivityLogLoader,
        activeOrganizationSubscriptionPlan,
        setActiveOrganizationSubscriptionPlan,
        isAddUpdatePurchaseDone,
        setIsAddUpdatePurchaseDone,

        GetTwoDecimalValueWithoutRoundOff,
        hasHyphenAfterNumber,
        getValidationMessage,
        logoutTimeUpModal,
        setLogoutTimeUpModal,

        isMenuVisible,
        setMenuVisible,
        toggleMenuVisibility,
        replaceTemplatePricingVariables
      }}
    >
      {children}
    </AuthContextProvider.Provider>
  );
};

export default AuthContext;
